import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import { useEffect } from 'react';

const PieChart = ({ chartId, logged, total, loggedLabel, nonLoggedLabel }) => {
  useEffect(() => {
    // Don't render chart if total is 0
    if (total === 0) {
      return;
    }

    let root = am5.Root.new(chartId);
    root._logo.dispose();

    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        startAngle: 180,
        endAngle: 360,
        layout: root.verticalLayout,
        innerRadius: am5.percent(50),
      })
    );

    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        startAngle: 180,
        endAngle: 360,
        valueField: 'value',
        categoryField: 'category',
        alignLabels: true,
      })
    );

    series.states.create('hidden', {
      startAngle: 180,
      endAngle: 180,
    });

    series.labels.template.setAll({
      forceHidden: true,
    });

    series.slices.template.setAll({
      cornerRadius: 5,
    });

    series.ticks.template.setAll({
      forceHidden: true,
    });

    series
      .get('colors')
      .set('colors', [am5.color('#287a9f'), am5.color('#c6cdd3')]);

    const notLogged = Math.max(total - logged, 0);

    // Filter out entries with value of 0 to prevent rendering small lines
    const chartData = [
      {
        value: logged,
        category: loggedLabel,
      },
      {
        value: notLogged,
        category: nonLoggedLabel,
      },
    ].filter(item => item.value > 0);

    // Only set data if there are items to display
    if (chartData.length > 0) {
      series.data.setAll(chartData);
      series.appear(1000, 100);
    }

    return () => {
      root.dispose();
    };
  }, [chartId, logged, total, loggedLabel, nonLoggedLabel]);

  return <div style={{ width: '100%', height: '270px' }} id={chartId}></div>;
};

export default PieChart;
